import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SessionStoreService } from '../../stores/session-store.service';
import { FeatureFlagsNames } from 'src/app/shared/constants/feature-flags.constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NewPortalRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionStore: SessionStoreService
  ) { }

  canActivate(): boolean | UrlTree {
    const releaseDate = new Date(2026, 2, 16); // Month is 0-based (2 = March)
    const canSeeNewPortal =
      new Date() >= releaseDate ||
      this.sessionStore.UserFeatureFlag?.some(
        x => x.FeatureFlag === FeatureFlagsNames.showNewPortal && x.FlagEnabled
      ) || !environment.production;

    if (canSeeNewPortal) {
      window.location.href = '/v2';
      return false;
    }

    return this.router.parseUrl('/Portal/Dashboard');
  }
}
